<template>
  <div
    :id="id"
    class="modal"
    data-backdrop="static"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog" :class="isMediumSize ? 'modal-md' : 'modal-xl'">
      <div class="modal-content">
        <div class="modal-header" v-if="headerTitle">
            <h4 class="font-medium text-base mr-auto font-bold">
                {{headerTitle}}
            </h4>
        </div>
        <div v-if="loading" class="absolute w-full h-full bg-black opacity-70">
          <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
        </div>
        <div class="modal-body p-4 md:p-10">
          <slot></slot>
        </div>
        <div class="flex flex-row justify-end items-center p-3 px-5" v-if="isViewOnly">
          <button class="btn  btn-primary mr-2" @click="handleSentOtherConnection" v-show="isSentOther">
            เลือกระบบที่ต้องการส่งข้อมูล
          </button>
          <button class="btn  btn-primary" @click="hideModal">
            ปิด
          </button>
        </div>
        <div class="flex flex-row justify-end items-center p-3 px-5" v-else>
          <button class="btn btn-secondary mr-2" @click="handleClickCancel" v-if="!isSaveOnly">
            ยกเลิก
          </button>
          <button class="btn btn-primary" :disabled="!isDone && isDisabledSubmit" @click="handleClickSave">
            บันทึก
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

//
<script>
// export default {
//   inheritAttrs: false,
// };
//
</script>

<script setup>
import { onMounted, watch } from "vue";
const props = defineProps({
  modelValue: Boolean,
  id: {
    type: String,
    default: "custom-modal",
  },
  loading: {
    type: Boolean,
    default: false,
  },
  headerTitle: String,
  isDone: {
    type: Boolean,
    default: false
  },
  isViewOnly:{
    type: Boolean,
    default: false
  },
  isSentOther:{
    type: Boolean
  },
  isSaveOnly:{
    type: Boolean,
    default: false
  },
  isDisabledSubmit:{
    type: Boolean,
    default: false
  },
  isMediumSize:{
    type: Boolean,
    default: false
  }
});
const emits = defineEmits(["update:modelValue", "click:cancel", "click:save","click:SentOtherConnection"]);

onMounted(() => {
  if (props.modelValue) {
    showModal();
  }
});

watch(
  () => props.modelValue,
  (newval) => {
    if (newval) {
      showModal();
    } else {
      hideModal();
    }
  }
);

const showModal = () => {
  cash(`#${props.id}`).modal("show");
};

const hideModal = () => {
  cash(`#${props.id}`).modal("hide");
  emits("update:modelValue", false);
};

const handleClickCancel = () => {
  hideModal();
  emits("click:cancel");
};
const handleSentOtherConnection = () => {
  emits("click:SentOtherConnection");
};
const handleClickSave = () => {
  watch(()=> props.isDone,(val)=>{
    if(val){
      hideModal();
    }
  })
  emits("click:save");
};
</script>
